import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgTips({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M15.471 20.05v.915c0 .728-.52 1.334-1.196 1.437l-.22.831a1.011 1.011 0 0 1-.97.767H10.91c-.457 0-.852-.316-.971-.767l-.213-.831a1.446 1.446 0 0 1-1.203-1.444v-.915c0-.49.382-.883.858-.883h5.232c.476.007.858.4.858.89ZM19.5 7.713c0 2.082-.802 3.97-2.105 5.356a7.155 7.155 0 0 0-1.842 3.84 1.251 1.251 0 0 1-1.228 1.077H9.669a1.24 1.24 0 0 1-1.221-1.07c-.22-1.437-.865-2.803-1.855-3.854A7.797 7.797 0 0 1 4.5 7.798C4.457 3.506 7.777.032 11.95 0c4.167-.032 7.55 3.435 7.55 7.714Zm-6.654-4.672a.859.859 0 0 0-.846-.87c-2.982 0-5.413 2.494-5.413 5.568 0 .477.376.87.846.87a.859.859 0 0 0 .846-.87c0-2.114 1.672-3.828 3.721-3.828.47 0 .846-.387.846-.87Z"
                    fill="#297A71"
                    fillRule="nonzero"
                />
            </g>
        </svg>
    )
}
SvgTips.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgTips
